import BasicButton from "../Usables/Buttons";
import Dropdown from "../Usables/Dropdown";
import { basePath } from '../Constants/constant';
import axios from 'axios';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { useState, useEffect , useCallback, useContext} from "react";
import { AppContext } from '../ContextApi/ContextApi';


const TodoForm = ({getTodoList}) => {
  const priorityOptions = [
    {value: "1", label: "Low"},
    {value: "2", label: "Mid"},
    {value: "3", label: "High"},
  ];
  
  const {apiHeaderJSON} = useContext(AppContext);
  const [recruiters, setRecruiters] = useState([]);
  const [formData, setFormData] = useState({ task_date: "1", send_email: true });
  const [errors, setErrors] = useState({});

  const getUserData = async () => {
    let options = {
      params:{
        for_task_assign:true
      },
      headers:apiHeaderJSON
    }
      let response = await axios.get(`${basePath}/getRecruiter`,options);
      // console.log(response.data);
      const recruiterList = response?.data?.map((val)=>{
          return {value: val?.id, label: val?.name, activated: val?.activated}
      });
      const listFilter = response?.data?.filter((val)=>{
          if(val?.activated === 1) return  val;
      });
      const activeList = listFilter?.map((val)=>{
          return {value: val?.id, label: val?.name, activated: val?.activated}
      });
      setRecruiters(activeList);
  };

const validateForm = () => {
        const errors = {};

        if (!formData?.task_description || formData?.task_description.trim() === "") {
            errors.task_description = "Task description is required";
            return errors;
        }
        if (!formData?.recruiter_id ) {
            errors.recruiter_id = "Recruiter selection is required";
            return errors;
        }
        if (!formData?.is_priority ) {
            errors.is_priority = "Priority selection is required";
            return errors;
        }

        return errors;
}

useEffect(() => {
    getUserData();         
}, []);

const handleChange = useCallback((event)=> {
    const {name, value} = event?.target;
    setFormData({ ...formData, [name]: value, });  
    setErrors({ ...errors, [name]: "", });  
},[formData, errors]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const errorList = validateForm();
    if (Object.keys(errorList).length > 0) {
      setErrors(errorList);
      return;
    }
    
     Swal.fire({
        title: 'Are you sure?',
        text: `You want to Assign Task!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Assign!',
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30',
        cancelButtonColor: '#F44336',
        allowOutsideClick: false,
      }).then(async (result) => {

          if (!result.isConfirmed) return;
            const config = {
                headers: apiHeaderJSON
            };
        
          try {
          const response = await axios.post(`${basePath}/Tasks/AssignTask`, formData, config);
            // console.log(`response ===>`, response);
          if (response.status === 200 && response.data?.success !== false) {
              setFormData({
              task_date: "1", 
              send_email: true,
              // task_title: "",
              task_description: "",
              recruiter_id: "",
              is_priority: "",
              });
              getTodoList();
              toast.success(response.data?.message || "Task Assigned Successfully");
          } else {
              toast.error(response.data?.message || "Unable to assign task");
          }
          } catch (error) {
              if (error.response) {
                  console.error("Job post Response error:", error.response.status, error.response.data);
                  toast.error(error.response.data?.message || "Failed to assign task");
              } else {
                  // Network or other error
                  console.error("Request error:", error.message);
                  toast.error("Network or unexpected error occurred.");
              }
          }
      });
  };

  const handleTaskDate = (e)=> {
    const {id} = e.target;
    setFormData({...formData, task_date: id });
  }

  return (
    <div className=" p-4 w-full">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4 w-full">
        {/* Task Title */}
        <label className="block text-left font-medium text-gray-700 mb-1">Task Date:</label>
        <div className="grid grid-cols-2 items-center gap-2">
          <div id="1" onClick={handleTaskDate} className={`${formData?.task_date === "1" ? " bg-blue-950 text-white grayBlurShadow" : "bg-white text-black border border-gray-400"} py-2 px-1 navAnimation rounded-lg cursor-pointer`}>
            Today
          </div>
          <div id="2" onClick={handleTaskDate} className={`${formData?.task_date === "2" ? " bg-blue-950 text-white grayBlurShadow" : "bg-white text-black border border-gray-400"} py-2 px-1 navAnimation rounded-lg cursor-pointer`}>
            Tomorrow
          </div>
        </div>
        {/* Task Note */}
        <div>
          <label
            htmlFor="task_description"
            className="block text-left font-medium text-gray-700 mb-1"
          >
            Task Description:
          </label>
          <textarea
            id="task_description"
            name="task_description"
            placeholder="Task Description*"
            value={formData?.task_description}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
            rows={3}  
          />
          {errors?.task_description && (<p className="text-red-500 text-sm mt-1 text-left">{errors?.task_description}</p>)}
        </div>

    <div className="grid grid-cols-2 items-start gap-2">
      {/* Recruiter Dropdown */}
      <Dropdown
        id="recruiter_id"
        name="recruiter_id"
        onChange={handleChange}
        value={formData?.recruiter_id}
        label="Recruiter:"
        className="rounded border bg-white border-gray-300 w-full text-[0.9rem]"
        placeholder="Select Recruiter"
        options={recruiters}
        error={errors?.recruiter_id}
      />
      <Dropdown
        id="is_priority"
        name="is_priority"
        onChange={handleChange}
        value={formData?.is_priority}
        label="Priority:"
        className="rounded border bg-white border-gray-300 w-full text-[0.9rem]"
        placeholder="Select Priority"
        options={priorityOptions}
        error={errors?.is_priority}
      />
    </div>
    {/* Is Priority Checkbox */}
    <div className="flex items-center gap-2 flex-1">
      <input
        id="send_email"
        name="send_email"
        type="checkbox"
        className="w-4 h-4  cursor-pointer text-blue-600 border-gray-300 rounded focus:ring focus:ring-blue-200"
        checked={formData?.send_email || false}
        onChange={(e) => setFormData({ ...formData, send_email: e.target.checked,})}
      />
      <label htmlFor="send_email" className="text-gray-700 text-md cursor-pointer select-none">
        Send Email?
      </label>
    </div>


        {/* Action Buttons */}
        <div className="flex justify-end gap-3 mt-4">
             <BasicButton type= 'submit'
             buttonName='Assign Task' className='darkPurple text-nowrap' shadow={true}  
            // disabled={loading} 
            // loading={loading} loadingMessage="Loading..."
            padding="py-2 px-10" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
          
        </div>
      </form>
    </div>
  );
};

export default TodoForm;